/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './ContextMenu.module.css'
import { addBeat, updateContext, updateGhostBeat, removeBeat, updateMouse, addAdditionalLabel, removeAdditionalLabel, selectActiveMarkingType } from '../../../Annotator/AnnotatorSlice'
import { ADDITIONAL_LABEL_TYPES } from '../../../../constants/annotator'

const ContextMenu = (props) => {
    const {
        beatLabel,
    } = props

    const dispatch = useDispatch()
    const ContextData = useSelector((state) => state.Annotator.context.data)
    const ActiveMarkingType = useSelector(selectActiveMarkingType)

    // Marks the sticky type that right-click will place. Note this is the
    // active *type*, not the label of the marking under the cursor.
    const isActive = (kind, value) =>
        ActiveMarkingType.kind === kind && ActiveMarkingType.value === value

    const {
        top = 0,
        left = 0,
        showDelete = false,
        beatIndex = null,
        additionalField = null,
    } = ContextData

    const closeMenu = () => {
        dispatch(updateContext({
            show : false,
            data : {
                top:0,
                left:0,
                showDelete:false,
                beatIndex:0,
                additionalField:null,
            }
        }))
        dispatch(updateGhostBeat({
            show : false,
        }))
    }

    // Both reclassify paths are destructive-by-design: a sample holds at most
    // one marking, so the add reducers clear whatever was there before. That
    // makes beat <-> p-wave/pace-spike conversion work in either direction.
    const createBeat = (type) => {
        dispatch(addBeat({type,beatIndex}))
        closeMenu()
    }

    const createAdditionalLabel = (field) => {
        dispatch(addAdditionalLabel({field, sampleIndex: beatIndex}))
        closeMenu()
    }

    const deleteMarking = (e) => {
        e.preventDefault();
        closeMenu()
        dispatch(updateMouse({
            mousedown : false,
            mouseDownOnBeat : false,
            mouseDownOnAdditionalField : null,
            posX : null,
            posY : null,
            iStart : null,
            bStart : null,
            dragging: null,
        }))
        if (additionalField) {
            dispatch(removeAdditionalLabel({ field: additionalField, sampleIndex: beatIndex }))
        } else {
            dispatch(removeBeat(beatIndex))
        }
    }
    
    return (
        <div
            id="contextMenu"
            style={{ top: top + (props.topOffset ?? 90), left }}
            className={styles.dropdownContent}
            onContextMenu={(e)=>{e.preventDefault()}}
        >
            {/* <a href="#" onClick={()=>{createBeat(1)}}>Noise</a> */}
            {beatLabel.map((label, i) => !label.name.includes("DEFAULT_") && (
                <a
                    href="#"
                    key={i}
                    style={{
                        backgroundColor: label.color,
                        filter: "alpha(opacity=10)",
                        fontWeight: isActive("beat", label.slug) ? "bold" : "normal",
                    }}
                    onClick={()=>{createBeat(label.slug)}}
                >
                    {isActive("beat", label.slug) ? `${label.name} ✓` : label.name}
                </a>
            ))}
            {ADDITIONAL_LABEL_TYPES.map((label) => (
                <a
                    href="#"
                    key={label.field}
                    style={{
                        backgroundColor: label.color,
                        borderTop: "1px solid #bbb",
                        fontWeight: isActive("additional", label.field) ? "bold" : "normal",
                    }}
                    onClick={()=>{createAdditionalLabel(label.field)}}
                >
                    {`${label.name} (${label.slug})${isActive("additional", label.field) ? " ✓" : ""}`}
                </a>
            ))}
           {showDelete && <a href="#" id="delete-beat" style={{ backgroundColor: '#aa2e25', color:'#fff'}} onClick={(e)=>{deleteMarking(e)}}>Delete</a>}
        </div>
    )
}

export default ContextMenu
